import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSettingsComponent } from './account-settings.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [AccountSettingsComponent],
  imports: [
    CommonModule
  ],
  exports: [AccountSettingsComponent]
})
export class AccountSettingsModule { }
